import { ColDef, ColGroupDef, ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';
import {
    ORG_CHART_HR_MAPPING,
    JOB_LABEL,
    JOB_NUMBER,
    ORG_CHART_HR_NAME,
} from 'routes/HumanResourcesModule/business/definitions';
import { getAgentColumn } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/agentColumnHelpers';
import { TEXT_FILTER } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/defaultColDefs';
import { orgChartHrFormatter } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/orgChartHrColumnHelpers';
import { getMantyStatusColumn } from 'routes/HumanResourcesModule/PayState/helpers/colDefinitions';
import { RecurrenceEnum } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';
import {
    isRowGrouped,
    isRowPinned,
} from 'routes/HumanResourcesModule/Simulation/helpers/gridHelpers';
import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import {
    AGENT_DEPARTURE_HYPOTHESIS,
    AGENT_DEPARTURE_HYPOTHESIS_TYPE,
} from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/Departure/helpers/constants';
import { START_DATE } from '../../../helpers/constants';
import { formatDate } from 'helpers/dateHelper';

const agentDepartureHypothesisCellRendererSelector = (
    params: ICellRendererParams,
) => {
    if (isRowGrouped(params)) return { component: 'agGroupCellRenderer' };
    if (isRowPinned(params)) return { component: undefined };
    return { component: 'agentDepartureHypothesisCellRenderer' };
};

export const getColDefs = (
    recurrence: RecurrenceEnum,
    hrSimulation: HrSimulation,
): (ColDef | ColGroupDef)[] => [
    {
        ...TEXT_FILTER,
        headerName: t(`humanResources.simulation.orgChartHrMapping`),
        field: ORG_CHART_HR_MAPPING,
        valueGetter: (params) => ({
            [ORG_CHART_HR_NAME]: params.data?.[ORG_CHART_HR_NAME],
            [ORG_CHART_HR_MAPPING]: params.data?.[ORG_CHART_HR_MAPPING],
        }),
        valueFormatter: (params) => {
            const orgChartHrName = params.value[ORG_CHART_HR_NAME] || '';
            const orgChartHrMapping = params.value[ORG_CHART_HR_MAPPING];
            return orgChartHrFormatter({ orgChartHrName, orgChartHrMapping });
        },
    },
    getAgentColumn(),
    {
        ...getMantyStatusColumn(),
        enableRowGroup: false,
    },
    ...[JOB_LABEL, JOB_NUMBER].map(
        (field): ColDef => ({
            ...TEXT_FILTER,
            headerName: t(`humanResources.simulation.${field}`),
            field,
        }),
    ),

    {
        ...TEXT_FILTER,
        headerName: t('humanResources.simulation.hypothesis'),
        field: AGENT_DEPARTURE_HYPOTHESIS,
        valueGetter: (params) => params.data,
        filterValueGetter: (params) => {
            return `${t(`humanResources.simulation.agentDepartureHypothesisType.${params.data[AGENT_DEPARTURE_HYPOTHESIS_TYPE]}`)} ${formatDate(new Date(params.data[START_DATE]))}`;
        },
        cellRendererSelector: agentDepartureHypothesisCellRendererSelector,
        cellRendererParams: {
            recurrence,
            isUpdateEnabled: false,
            hrSimulation,
        },
    },
];
